import React from 'react';
import styled, { css } from 'styled-components';
import { forDesktop, forTablet, forWideScreens } from '@westwing/ui-kit/breakPoints';
import { NotificationMessage } from '../../redux/notifications/types';
import NotificationBanner from './NotificationBanner';
import { HeaderModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';

const NotificationsArea = styled.div<{ isBannerShown?: boolean; isSticky: boolean; bottom?: boolean }>`
    position: ${({ isSticky }) => (isSticky ? 'sticky' : 'static')};
    z-index: ${({ theme }) => theme.zIndexBelowContentOverlay};
    ${({ isBannerShown }) =>
        isBannerShown
            ? css`
                  top: ${({ theme }) => theme.notificationBarTopHeight.mobile};
                  ${forTablet`
                    top: ${({ theme }) => theme.notificationBarTopHeight.tablet};
                  `}
                  ${forDesktop`
                    top: ${({ theme }) => theme.notificationBarTopHeight.desktop};
                  `}
                  ${forWideScreens`
                     top: ${({ theme }) => theme.notificationBarTopHeight.wideScreens};
                  `}
              `
            : css`
                  top: ${({ theme }) => theme.oneHeaderModuleHeight}px;
                  ${forDesktop`
                    top: 0;
                  `}
              `}

    ${({ bottom }) =>
        bottom &&
        css`
            position: absolute;
            top: auto;
            ${forDesktop`
                top: auto;
            `}
            bottom: 0;
            width: 100%;
        `}
`;

const FlowBreaker = styled.div<{ bottom?: boolean }>`
    z-index: inherit;
    position: absolute;
    ${({ bottom }) =>
        bottom &&
        css`
            position: relative;
        `}
    width: 100%;
`;

interface NotificationsProps {
    messages: NotificationMessage[];
    dismissMessage: (messageId: string) => void;
    isBannerShown?: boolean;
    position?: 'bottom' | 'top';
}

const Notifications: React.SFC<NotificationsProps> = ({
    messages,
    dismissMessage,
    isBannerShown,
    position,
    ...rest
}) => {
    const { headerMode } = useLayoutByPage();

    return (
        <NotificationsArea
            isBannerShown={isBannerShown}
            isSticky={headerMode === HeaderModeType.DEFAULT}
            bottom={position === 'bottom'}
            {...rest}
        >
            <FlowBreaker bottom={position === 'bottom'}>
                {messages.map(({ text, id, autoHideIntervalSeconds, displayType, isSticky, dismissable }) => (
                    <NotificationBanner
                        key={id}
                        message={text}
                        messageId={id}
                        displayType={displayType}
                        autoHideIntervalSeconds={isSticky ? undefined : autoHideIntervalSeconds}
                        isSticky={isSticky}
                        dismissable={dismissable}
                        onMessageDismissed={dismissMessage}
                    />
                ))}
            </FlowBreaker>
        </NotificationsArea>
    );
};

export default Notifications;
